/* eslint no-script-url: 0 */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../../services/utilityFunctions';
import translate from '../../translate';
import withCSRF from '../../withCSRF';
import withLoggedUser from '../../withLoggedUser';

/**
 * Metronic's brand display and side menu toggler
 */
function OrganizationList({ t, _csrf, organizationId, authOrganizations }) {
  const id = 'organizationAuth';

  useEffect(() => {
    const selectElement = $(`#${id}`);
    selectElement.select2({ allowClear: false });
    selectElement.on('select2:select', evt => {
      document.getElementById('organizationAuthForm').submit();
    });
    return () => {
      selectElement.select2('destroy');
    };
  }, []);

  return (
    <div
      id="m_header_topbar"
      className="m-topbar  m-stack m-stack--ver m-stack--general"
    >
      <div className="m-stack__item m-topbar__nav-wrapper">
        <ul className="m-topbar__nav m-nav m-nav--inline">
          {authOrganizations.length > 1 && (
            <li className="m-nav__item">
              <div
                className="m-nav__link"
                style={{
                  height: '100%',
                  position: 'relative',
                  top: '20%',
                  marginRight: '15px',
                  minWidth: '250px',
                }}
              >
                <form
                  id="organizationAuthForm"
                  method="post"
                  action="/signin/switch/organization"
                >
                  <input type="hidden" name="_csrf" value={_csrf} />
                  <select
                    id={id}
                    name={id}
                    className="form-control"
                    style={{ height: '3rem' }}
                    onChange={() =>
                      document.getElementById('organizationAuthForm').submit()
                    }
                    defaultValue={organizationId}
                  >
                    <optgroup label={t('your.organizations')}>
                      {authOrganizations.map(authOrganization => (
                        <option
                          key={authOrganization._id}
                          value={authOrganization._id}
                        >
                          {authOrganization.name}
                        </option>
                      ))}
                    </optgroup>
                  </select>
                </form>
              </div>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}

OrganizationList.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  organizationId: PropTypes.string,
  authOrganizations: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
};

OrganizationList.defaultProps = {
  organizationId: null,
  authOrganizations: [],
};

export default compose(translate, withCSRF, withLoggedUser)(OrganizationList);
